import { render, staticRenderFns } from "./SafetyMeasuresHeader.vue?vue&type=template&id=10f711bd&scoped=true&"
import script from "./SafetyMeasuresHeader.vue?vue&type=script&lang=js&"
export * from "./SafetyMeasuresHeader.vue?vue&type=script&lang=js&"
import style0 from "./SafetyMeasuresHeader.vue?vue&type=style&index=0&id=10f711bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f711bd",
  null
  
)

export default component.exports